
<script>
import { mapGetters, mapActions } from 'vuex'

/**
 * Components
 *
 */
import EntryDialog from '@/components/uicomp/ModalDialog-Form-Single'
const components = {
  EntryDialog,
}

/**
 * Static Data
 *
 */
const data = function () {
  return {
    input: {}
  }
}

/**
 * Computed
 *
 */
const computed = mapGetters({
  processing: `Employee/loadingState`
})
computed.validate = function() {
  return !!this.input.name && !this.processing
}

/**
 * Methods
 *
 */
const methods = mapActions({
  entry: `Employee/update`
})

methods.reset = function() {
  this.input = {}
}

methods.show = function() {
  this.$refs.EntryDialog.show()
}

methods.addrecord = async function() {
  const data = this.input
  const id = await this.entry({ data })

  if (id) {
    this.$router.push(`/employee/${id}`)
    this.$refs.EntryDialog.dismiss()
  }
}

export default {
  components,
  data,
  computed,
  methods,
}
</script>

<style scoped>
</style>

<template>
  <EntryDialog ref="EntryDialog" :valid="validate" @submit="addrecord">
    <FormGroup>
      <TextField
        label="Nama Karyawan"
        :forceupper=true
        v-model="input.name" />
    </FormGroup>
  </EntryDialog>
</template>